interface ResumeDebugOptions {
  searchParams: URLSearchParams;
  isDev: boolean;
  showPanelEnv: string | undefined;
  localStorageValue?: string | null;
}

export const hasResumeDebugParam = (searchParams: URLSearchParams): boolean =>
  searchParams.get("rrdebug") === "1" || searchParams.get("rrdebug") === "true";

export const resolveResumeDebugEnabled = ({
  searchParams,
  isDev,
  showPanelEnv,
  localStorageValue,
}: ResumeDebugOptions): boolean => {
  if (isDev) {
    return true;
  }
  if (showPanelEnv !== "true") {
    return false;
  }
  if (hasResumeDebugParam(searchParams)) {
    return true;
  }
  return localStorageValue === "1";
};
